export default {"src":"/_next/static/media/ardr.43a794fc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};